import { adminHttpClient } from '../commons/adminHttpClient'

export type EEParticipationStatusStatisticResponse = {
  newTotal: number
  invitedTotal: number
  pendingTotal: number
  optedInTotal: number
  optedOutTotal: number
  activeTotal: number
  total: number
}

const getEEParticipationStatusStatistic = (planPeriodId: string): Promise<EEParticipationStatusStatisticResponse> => {
  return adminHttpClient.get(`/Benefit/EligibleEmployeeParticipationStatusStatistic/${planPeriodId}`)
}

export default getEEParticipationStatusStatistic
